/**
 * Count everyone signed up for an event EXCEPT the host.
 *
 * The roster lives in four arrays on the event doc (rsvp'd or checked-in, on
 * either side). onEventCreate seeds the host into rsvpSitters, so a brand-new
 * event with no real guests still has one uid sitting in there — a raw length
 * check would never read as empty, which is exactly the case callers care about.
 *
 * Mirrors collectAttendeeUids() in the backend's eventCancellation.js. Keep the
 * two in sync: the server is the authority on whether a delete needs the
 * cancel-first flow, this is what the UI uses to offer it.
 */
export const countEventGuests = (eventData) => {
  const uids = new Set();
  [eventData?.rsvpSitters, eventData?.sitters, eventData?.rsvpMovers, eventData?.movers].forEach(
    (list) =>
      Array.isArray(list) &&
      list.forEach((uid) => {
        if (uid && uid !== eventData?.vendorID) uids.add(uid);
      })
  );
  return uids.size;
};
